import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Nomenclatoare/NomenclatoareModels.cs ----------

export type ArticleType = 'ProdusFinit' | 'Semifabricat' | 'MateriePrima' | 'Ambalaj' | 'Serviciu' | 'Set'
export type ArticleFamily = 'Pahar' | 'Caserola' | 'Cheseta' | 'Capac' | 'Platina' | 'Insert' | 'Altele'
export type MarketSegment = 'Lapte' | 'Delicatese' | 'Blistere' | 'Altele'
export type ArticleMaterial = 'PS' | 'PP' | 'Alu' | 'Altele'

export interface UnitOfMeasure { id: string; code: string; name: string; isActive: boolean }

export interface ArticleUnitConversion { unitOfMeasureId: string; unitOfMeasureCode: string; factorToPrimary: number }
export interface ArticleSetComponent { componentArticleId: string; componentArticleCode: string; componentArticleDescription: string; quantity: number }

export interface ArticleListItem {
  id: string
  code: string
  oldCode: string | null
  shortDescription: string
  type: ArticleType
  family: ArticleFamily | null
  primaryUnitOfMeasureCode: string
  standardCost: number | null
  isActive: boolean
  vatRateId: string | null
}

export interface ArticleDetail {
  id: string
  code: string
  oldCode: string | null
  shortDescription: string
  longDescription: string | null
  type: ArticleType
  family: ArticleFamily | null
  marketSegment: MarketSegment | null
  material: ArticleMaterial | null
  diameterMm: number | null
  volumeMl: number | null
  weightG: number | null
  unitWeightG: number | null
  primaryUnitOfMeasureId: string
  secondaryUnitOfMeasureId: string | null
  secondaryConversionFactor: number | null
  unitsPerBox: number | null
  boxesPerPallet: number | null
  standardCost: number | null
  minMarginPercent: number | null
  vatRateId: string | null
  customsCode: string | null
  requiresLotTraceability: boolean
  requireCompleteSetDelivery: boolean
  minStockQuantity: number | null
  isActive: boolean
  unitConversions: ArticleUnitConversion[]
  setComponents: ArticleSetComponent[]
}

export interface SaveArticlePayload {
  code: string
  oldCode?: string | null
  shortDescription: string
  longDescription?: string | null
  type: ArticleType
  family?: ArticleFamily | null
  marketSegment?: MarketSegment | null
  material?: ArticleMaterial | null
  diameterMm?: number | null
  volumeMl?: number | null
  weightG?: number | null
  unitWeightG?: number | null
  primaryUnitOfMeasureId: string
  secondaryUnitOfMeasureId?: string | null
  secondaryConversionFactor?: number | null
  unitsPerBox?: number | null
  boxesPerPallet?: number | null
  standardCost?: number | null
  minMarginPercent?: number | null
  vatRateId?: string | null
  customsCode?: string | null
  requiresLotTraceability: boolean
  requireCompleteSetDelivery: boolean
  minStockQuantity?: number | null
  unitConversions: { unitOfMeasureId: string; factorToPrimary: number }[]
  setComponents: { componentArticleId: string; quantity: number }[]
}

// ---------- UM ----------

export const listUnits = () => api.get<UnitOfMeasure[]>('/nomenclatoare/um').then((r) => r.data)
export const createUnit = (payload: { code: string; name: string }) =>
  api.post<{ id: string }>('/nomenclatoare/um', payload).then((r) => r.data)
export const updateUnit = (id: string, payload: { code: string; name: string }) =>
  api.put(`/nomenclatoare/um/${id}`, payload)
export const deactivateUnit = (id: string) => api.post(`/nomenclatoare/um/${id}/deactivate`)

// ---------- articole ----------

export const listArticles = (search?: string, sets = false) =>
  api.get<ArticleListItem[]>('/nomenclatoare/articole', { params: { search: search || undefined, sets } }).then((r) => r.data)

export const getArticle = (id: string) => api.get<ArticleDetail>(`/nomenclatoare/articole/${id}`).then((r) => r.data)

export const createArticle = (payload: SaveArticlePayload) =>
  api.post<{ id: string }>('/nomenclatoare/articole', payload).then((r) => r.data)

export const updateArticle = (id: string, payload: SaveArticlePayload) =>
  api.put(`/nomenclatoare/articole/${id}`, payload)

export const deactivateArticle = (id: string) => api.post(`/nomenclatoare/articole/${id}/deactivate`)
